export default __webpack_public_path__ + "static/media/medicalenggrepeaterbannerMweb.b10eb6b5.png";